const route = '//www.flushingorthodontics.com/wp-json'

const api = () => {
  try {
    return 'https://' + route
  } catch (e) {
    return 'https://' + route
  }
}

export default api()



// WEBPACK FOOTER //
// ./src/shared/api/api.js